import { MerchandiseShippingOrderCreationItem } from 'api/order'
import getMerchandiseShippingItemViews from 'checkout/selectors/view/itemViews/getMerchandiseShippingItemViews'
import { createSelector } from 'reselect'

const getFormattedMerchandiseShippingItems = createSelector(
  (state: App.State) => getMerchandiseShippingItemViews(state),
  (state: App.State) => state.destination.googlePlaces[state.checkout.form.deliveryForm.addressPlaceId ?? ''],
  (views, address): Array<MerchandiseShippingOrderCreationItem> => {
    return views.data.map(view => {
      return {
        type: 'merchandise_shipping',
        transaction_key: view.item.transactionKey,
        total: view.totals.otherFees?.deliveryFee ?? 0,
        shippingGroup: view.item.shippingId,
        address: {
          address: address?.addressDetails.streetAddress,
          city: address?.addressDetails.city,
          state: address?.addressDetails.state,
          country: address?.addressDetails.country,
          postcode: address?.addressDetails.postcode,
        },
      }
    })
  }
)

export default getFormattedMerchandiseShippingItems
